import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Pagination from 'Components/Common/pagination';
import queryString from "query-string";
import SmrTableStore from 'Stores/smrTableStore';
import 'Styles/commonComponents/SmrTable.scss';
import LoadView from "Components/Common/loadView";

/**
 * @template TData
 * @typedef {object} props
 * @property {{ 
 *  left: React.JSX.Element[] | React.JSX.Element | string | undefined, 
 *  right: React.JSX.Element[] | React.JSX.Element | string | undefined
 * }} [buttonsPanel]
 * @property {() => React.JSX.Element} renderHeader
 * @property {(arg0: TData) => React.JSX.Element} renderTableLine
 * @property {string} [className]
 * @property {number} [elementsPerPage]
 * @property {number} [rowHeight]
 * @property {boolean} [switchPaginationOff]
 * @property {string} [loadText]
 * @property {string} [placeholderText]
 * @property {Location} [location]
 * @property {boolean} [loading]
 */

/**
 * @template T
 * @extends {Component<props<T>>}
 */
class SmrTable extends Component {
    /** @type {SmrTableStore<T>} */
    store;
    rowHeightDefault = 50;
    paginationMoves = {};

    /**
     * @param {props<T>} props
     */
    constructor(props) {
        super(props);

        this.store = new SmrTableStore(props.elementsPerPage);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        if (this.props.elementsPerPage == null) {
            let rowsContainerHeight = document.getElementById("smr-row-holder")?.clientHeight;
            if (rowsContainerHeight > 0) {
                let elementsPerPage = Math.trunc((rowsContainerHeight - 10 /* костыль для отступов на разных страницах */) / (this.props.rowHeight ?? this.rowHeightDefault));
                this.store.paginationInfo.elementsPerPage = Math.max(elementsPerPage, 1);
            }
        }

        this.props.setTableStore(this.store);
        const params = queryString.parse(this.props.location.search);
        let startPage = 1;
        if (params.page != null && !isNaN(+params.page) && +params.page > 0)
            startPage = (+params.page);

        this.props.getDataPage(startPage);
        document.getElementById('smr-row-holder')?.addEventListener('scroll', this.handleScroll);

        this.paginationMoves = {
            first: _ => this.props.getDataPage(1),
            prev: _ => this.props.getDataPage(this.store.paginationInfo.currentPage - 1),
            next: _ => this.props.getDataPage(this.store.paginationInfo.currentPage + 1),
            last: _ => this.props.getDataPage(this.store.paginationInfo.pageCount),
            concrete: page => this.props.getDataPage(page)
        };
    }

    /**
     * @param {Event} event 
     */
    handleScroll(event) {
        var header = document.getElementById('table-header');
        if (header && event.target instanceof Element)
            header.scrollLeft = event.target.scrollLeft;
    }

    componentWillUnmount() {
        document.getElementById('smr-row-holder')?.removeEventListener('scroll', this.handleScroll);

        if (this.props.cleanTableData != null)
            this.props.cleanTableData();

        if (this.props.cleanTableStore != null)
            this.props.cleanTableStore();
    }

    render() {
        let lines = [];

        if (this.props.loading) {
            lines = (
                <LoadView
                    loading={this.props.loading}
                    loadText={this.props.loadText} />
            );
        } else {
            for (let i = 0; i < this.store.data.length; i++)
                lines.push(this.props.renderTableLine(this.store.data[i]));

            if (lines.length === 0) {
                lines = (
                    <div className="lines-placeholder" key='lines_placeholder'>
                        {this.props.placeholderText ?? 'Записи отсутствуют'}
                    </div>
                );
            }
        }

        let tableClass = '';

        if (this.props.className != null)
            tableClass = this.props.className;

        return (
            <div className={`smr-table ${tableClass}`}>
                <div className="smr-table-header-with-lines">
                    <div className="smr-table-header header-scroll-container"
                        id="table-header">
                        {this.props.renderHeader()}
                    </div>
                    <div id="smr-row-holder"
                        className="smr-table-rows lines-container overflowing-element">
                        {lines}
                    </div>
                </div>
                <div className='buttons-container'>
                    <div className='left-buttons-container'>
                        {this.props.buttonsPanel?.left}
                    </div>
                    {
                        this.props.switchPaginationOff === true ? '' :
                            <Pagination paginationInfo={this.store.paginationInfo}
                                moves={this.paginationMoves}
                                disableAll={this.props.loading} />
                    }
                    <div className='right-buttons-container'>
                        {this.props.buttonsPanel?.right}
                    </div>
                </div>
            </div>
        );
    }
}

export default observer(SmrTable);